import * as m from "./../../dist/es2015/gantt.js";
export const am5gantt = m;